import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGameNumberSense";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";
//ratio images
import Emile1 from "../../assets/NumberSense/Images/emile1.png";
import Emile2 from "../../assets/NumberSense/Images/emile2.png";
import Emile3 from "../../assets/NumberSense/Images/emile3.png";
import Emile4 from "../../assets/NumberSense/Images/emile4.png";
import Emile5 from "../../assets/NumberSense/Images/emile5.png";
import aimee1 from "../../assets/NumberSense/Images/aimee1.png";
import aimee2 from "../../assets/NumberSense/Images/aimee2.png";
import aimee3 from "../../assets/NumberSense/Images/aimee3.png";
import aimee4 from "../../assets/NumberSense/Images/aimee4.png";
import aimee5 from "../../assets/NumberSense/Images/aimee5.png";
import rocket1 from "../../assets/NumberSense/Images/rocket1.png";
import rocket2 from "../../assets/NumberSense/Images/rocket2.png";
import rocket3 from "../../assets/NumberSense/Images/rocket3.png";
import rocket4 from "../../assets/NumberSense/Images/rocket4.png";
import rocket5 from "../../assets/NumberSense/Images/rocket5.png";
import scrambler1 from "../../assets/NumberSense/Images/scrambler1.png";
import scrambler2 from "../../assets/NumberSense/Images/scrambler2.png";
import scrambler3 from "../../assets/NumberSense/Images/scrambler3.png";
import scrambler4 from "../../assets/NumberSense/Images/scrambler4.png";
import scrambler5 from "../../assets/NumberSense/Images/scrambler5.png";
import triangle1 from "../../assets/NumberSense/Images/triangle1.png";
import triangle2 from "../../assets/NumberSense/Images/triangle2.png";
import triangle3 from "../../assets/NumberSense/Images/triangle3.png";
import triangle4 from "../../assets/NumberSense/Images/triangle4.png";
import triangle5 from "../../assets/NumberSense/Images/triangle5.png";
import rectangle1 from "../../assets/NumberSense/Images/rectangle1.png";
import rectangle2 from "../../assets/NumberSense/Images/rectangle2.png";
import rectangle3 from "../../assets/NumberSense/Images/rectangle3.png";
import rectangle4 from "../../assets/NumberSense/Images/rectangle4.png";
import rectangle5 from "../../assets/NumberSense/Images/rectangle5.png";
import Table from "../../assets/NumberSense/Images/tableratios.png";

function ReturnRatioImage(image, number) {
  if (image == "Emile") {
    if (number == 1) {
      return Emile1;
    }
    if (number == 2) {
      return Emile2;
    }
    if (number == 3) {
      return Emile3;
    }
    if (number == 4) {
      return Emile4
    }
    if (number == 5) {
      return Emile5
    }
  }
  if (image == "Aimee") {
    if (number == 1) {
      return aimee1;
    }
    if (number == 2) {
      return aimee2;
    }
    if (number == 3) {
      return aimee3;
    }
    if (number == 4) {
      return aimee4
    }
    if (number == 5) {
      return aimee5
    }
  }
  if (image == "Triangle") {
    if (number == 1) {
      return triangle1;
    }
    if (number == 2) {
      return triangle2;
    }
    if (number == 3) {
      return triangle3;
    }
    if (number == 4) {
      return triangle4
    }
    if (number == 5) {
      return triangle5
    }
  }
  if (image == "Scrambler") {
    if (number == 1) {
      return scrambler1;
    }
    if (number == 2) {
      return scrambler2;
    }
    if (number == 3) {
      return scrambler3;
    }
    if (number == 4) {
      return scrambler4
    }
    if (number == 5) {
      return scrambler5
    }
  }
  if (image == "Rectangle") {
    if (number == 1) {
      return rectangle1;
    }
    if (number == 2) {
      return rectangle2;
    }
    if (number == 3) {
      return rectangle3;
    }
    if (number == 4) {
      return rectangle4
    }
    if (number == 5) {
      return rectangle5
    }
  }
  if (image == "Rocket") {
    if (number == 1) {
      return rocket1;
    }
    if (number == 2) {
      return rocket2;
    }
    if (number == 3) {
      return rocket3;
    }
    if (number == 4) {
      return rocket4
    }
    if (number == 5) {
      return rocket5
    }
  }
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


function AddGrams(qText){
  console.log(qText);
  let arr = qText.split(' ');
  var checker;
  var newText = '';

  for(var i = 0; i < arr.length; i++){
    checker = arr[i];
    if(!isNaN(+checker)){
      if(checker >= 1){
      console.log(checker);
      arr[i] = checker + 'g';
      }
    }
  }


  for(var i = 0; i < arr.length; i++){
    newText += arr[i] + ' ';
  }
  console.log(newText);
  return newText;


}



function GenerateQuestion(q) {
  console.log(q.right_answer);
  //All the shared variables
  let questionAnswers = [];
  //Add the correct answer
  questionAnswers.push({ correct: true, value: q.right_answer });
  //Add the wrong answers
  questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_3 });
  var html;

  //question html if topic = Ratio1
  if (q.topic_key == "Ratio1") {
    var images = q.images.split(":");
    var amounts = q.right_answer.split(":");
    html = '<img src="' + ReturnRatioImage(images[0], parseInt(amounts[0])) + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
    html += '<img src="' + ReturnRatioImage(images[1], parseInt(amounts[1])) + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }
  if (q.topic_key == "Ratio3") {
    var table = q.images.split(",");
    table[0] = table[0].replace("Table of ","");
    html = '<img src="' + Table + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:34% ; right:51.5%'>" + table[0] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:63% ; right:51.5%'>" + table[1] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:34% ; right:15%'>" + table[2] + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:63% ; right:15%'>" + table[3] + "</b>";
  }

  shuffleArray(questionAnswers);
  console.log(q.question_line_2);

if(q.topic_id == "1772"){
  let questionObj = {
    question: AddGrams(q.question_line_1),
    question2: q.question_line_2,
    answers: questionAnswers,
    topic_id: q.topic_id,
    questionHTML: html
  };

  return questionObj;

} else{
  let questionObj = {
    question: q.question_line_1,
    question2: q.question_line_2,
    answers: questionAnswers,
    topic_id: q.topic_id,
    questionHTML: html
  };

  return questionObj;

}
}

export default function Rating({ ...props }) {
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() => {
    if (questions !== undefined) {
      let levelQs = [];
      questions.forEach((levelQuestions, i) => {

        var newLevelQuestions = [];
        levelQuestions.forEach(q => {
          console.log(q);
          console.log(q.right_answer);
          for (var i = 1; i < 12; i++) {
            var questionObj = GenerateQuestion(q);
            newLevelQuestions.push(questionObj);
          }
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
        console.log(newLevelQuestions);
      });
      setLevels(levelQs);
    }
    console.log("ALL LEVELS");
    console.log(levels);
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() => {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
